import React, { Component } from 'react';
import { Rect, Text, Group } from 'react-konva';

export class ExceptionsComponentCanvas extends Component {
    render() {
        const { geometry, component, isSelected, dimentionsRatio, draggable } = this.props;

        const geometryWidthRatio = geometry.width / 1200.0 * dimentionsRatio;
        const geometryHeightRatio = geometry.height / 500.0 * dimentionsRatio;

        const height = 100 * geometryHeightRatio;
        const smallWidth = 100 * geometryWidthRatio;
        const bigWidth = 950 * geometryWidthRatio;

        const firstElementPosX = geometry.drawPositionX + 50 * geometryWidthRatio;
        const secondElementPosX = geometry.drawPositionX + 200 * geometryWidthRatio;
        const firstElementPosY = geometry.drawPositionY + 50 * geometryHeightRatio;
        const secondElementPosY = geometry.drawPositionY + 200 * geometryHeightRatio;
        const thirdElementPosY = geometry.drawPositionY + 350 * geometryHeightRatio;

        const componentSecundaryColor = "#DCEEF6";
        const geometryWidth = geometry.width * dimentionsRatio;
        const geometryHeight = geometry.height * dimentionsRatio;
        
        let fontSize = height;
        if (6 * fontSize > geometryWidth) {
            fontSize = geometryWidth / 6.0;
        }

        return (
            <Group
                offsetX={geometry.offsetX}
                offsetY={geometry.offsetY}
                draggable={draggable}
                onDragEnd={this.props.onDragEnd}
                onClick={this.props.onComponentClick ? () => this.props.onComponentClick(component.internalId) : null} >
                <Rect x={geometry.drawPositionX}
                    y={geometry.drawPositionY}
                    width={geometryWidth}
                    height={geometryHeight}
                    strokeWidth={isSelected ? 3 : 1}
                    stroke={isSelected ? "#6699ff" : "black"}
                    fill={component.color} />

                <Group>
                    <Text text={component.text}
                        fontSize={fontSize}
                        x={firstElementPosX}
                        y={firstElementPosY} />
                </Group>

                <Group>
                    <Rect x={firstElementPosX}
                        y={secondElementPosY}
                        width={smallWidth}
                        height={height}
                        strokeWidth={1}
                        stroke="black"
                        fill={componentSecundaryColor} />
                    <Rect x={secondElementPosX}
                        y={secondElementPosY}
                        width={bigWidth}
                        height={height}
                        strokeWidth={1}
                        stroke="black"
                        fill={componentSecundaryColor} />
                </Group>

                <Group>
                    <Rect x={firstElementPosX}
                        y={thirdElementPosY}
                        width={smallWidth}
                        height={height}
                        strokeWidth={1}
                        stroke="black"
                        fill={componentSecundaryColor} />
                    <Rect x={secondElementPosX}
                        y={thirdElementPosY}
                        width={bigWidth}
                        height={height}
                        strokeWidth={1}
                        stroke="black"
                        fill={componentSecundaryColor} />
                </Group>
            </Group>
        );
    }
}
